export const CREATE_UNIT_RECORD = "CREATE_UNIT_RECORD";
export const CREATE_UNIT_RECORD_BULK = "CREATE_UNIT_RECORD_BULK";
export const FETCH_UNIT_RECORDS = "FETCH_UNIT_RECORDS";
export const FETCH_UNIT_RECORD = "FETCH_UNIT_RECORD";
export const EDIT_UNIT_RECORD = "EDIT_UNIT_RECORD";
export const DELETE_UNIT_RECORD = "DELETE_UNIT_RECORD";
